/*
 *
 * Home reducer
 *
 */

import { fromJS } from "immutable"
import {
  GET_USER_MANDU_WATCHER,
  GET_USER_MANDU_FAILED,
  GET_USER_MANDU_SUCCESS,
  GET_USER_CREATE_MANDU_WATCHER,
  GET_USER_CREATE_MANDU_FAILED,
  GET_USER_CREATE_MANDU_SUCCESS,
  SAVE_COMPANY_USER_ACCESS_MANDU_FAILED,
  SAVE_COMPANY_USER_ACCESS_MANDU_SUCCESS,
  SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER,
  DELETE_COMPANY_USER_ACCESS_MANDU_FAILED,
  DELETE_COMPANY_USER_ACCESS_MANDU_SUCCESS,
  DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER,
  USER_SAVE_WATCHER,
  USER_SAVE_SUCCESS,
  USER_SAVE_FAILED,
  GET_OPTIONS_WATCHER,
  GET_OPTIONS_SUCCESS,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  users: [],
  user_create: [],
  save_loading: false,
  companiesAccessLoading: false,
  companiesAccessData: [],
  options: {
    sizes: [],
    collaborators: [],
    services: [],
    sectors: [],
    country: [],
  },
})

function homeReducer(state = initialState, action) {
  switch (action.type) {
    case GET_USER_CREATE_MANDU_WATCHER:
      return state.set("isLoading", true).set("user_create", [])
    case GET_USER_CREATE_MANDU_SUCCESS:
      return state.set("isLoading", false).set("user_create", action.payload)
    case GET_USER_CREATE_MANDU_FAILED:
      return state.set("isLoading", false).set("user_create", [])
    case SAVE_COMPANY_USER_ACCESS_MANDU_WATCHER:
      return state
        .set("companiesAccessLoading", true)
        .set("companiesAccessData", [])
    case SAVE_COMPANY_USER_ACCESS_MANDU_SUCCESS:
      return state
        .set("companiesAccessLoading", false)
        .set("companiesAccessData", action.payload)
    case SAVE_COMPANY_USER_ACCESS_MANDU_FAILED:
      return state
        .set("companiesAccessLoading", false)
        .set("companiesAccessData", [])
    case DELETE_COMPANY_USER_ACCESS_MANDU_WATCHER:
      return state
        .set("companiesAccessLoading", true)
        .set("companiesAccessData", [])
    case DELETE_COMPANY_USER_ACCESS_MANDU_SUCCESS:
      return state
        .set("companiesAccessLoading", false)
        .set("companiesAccessData", action.payload)
    case DELETE_COMPANY_USER_ACCESS_MANDU_FAILED:
      return state
        .set("companiesAccessLoading", false)
        .set("companiesAccessData", [])
    case GET_USER_MANDU_WATCHER:
      return state.set("isLoading", true).set("users", [])
    case GET_USER_MANDU_SUCCESS:
      return state.set("isLoading", false).set("users", action.payload)
    case GET_USER_MANDU_FAILED:
      return state.set("isLoading", false).set("users", [])
    case USER_SAVE_WATCHER:
      return state.set("save_loading", true)
    case USER_SAVE_SUCCESS:
      return state.set("save_loading", false)
    case USER_SAVE_FAILED:
      return state.set("save_loading", false)
    case GET_OPTIONS_WATCHER:
      return state.set("options", {
        sizes: [],
        collaborators: [],
        services: [],
        sectors: [],
        country: [],
      })
    case GET_OPTIONS_SUCCESS:
      return state.set("options", action.payload)
    default:
      return state
  }
}

export default homeReducer
